/**
 * @file Bouton « FX » du hub : un seul geste pour masquer / reafficher TOUS les effets cosmetiques (les miens et ceux des autres joueurs).
 *       Le reglage fin (mes effets / ceux des autres) est dans Reglages. Pur, teste.
 */

export interface FxVisibility {
  fxSelf: boolean;
  fxOthers: boolean;
}

/** Au moins un groupe d'effets visible : le bouton est « allume ». */
export const fxAnyVisible = (s: FxVisibility): boolean => s.fxSelf || s.fxOthers;

/** Appui sur le bouton : quelque chose est visible -> tout masquer ; rien de visible -> tout reafficher. */
export const toggleAllFx = (s: FxVisibility): FxVisibility => (fxAnyVisible(s) ? { fxSelf: false, fxOthers: false } : { fxSelf: true, fxOthers: true });
